import { render, staticRenderFns } from "./mr_widget_container.vue.js?vue&type=template&id=0c4febe0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mr_widget_container.vue?vue&type=template&id=0c4febe0"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports